<template>
    <!-- 保單卡片 -->
    <div class="mb-4 md:mb-8 ">
        <div class="md:shadow-3 rounded overflow-hidden">
            <!-- title -->
            <div class="h-10 -mb-0.5 align-top py-3 pl-2.5 relative shine">
                <div class="h-12" />
            </div>
            <!-- content -->
            <div class="ring-1 ring-slate-100 ring-inset rounded-b transition-all duraion-200 bg-white pb-2 md:pb-4">
                <div class=" pt-4 pb-3 md:pb-5 px-2.5 pad:min-h-[4.375rem] min-h-[3rem]">
                    <div class="shine rounded-lg w-1/2" />
                </div>
                <transition-group name="expand">
                    <template
                        v-for="(content, i) in contentArray"
                        :key="i"
                    >
                        <div
                            v-if="content.show"
                            v-show="!content.isFold"
                            class="py-2 px-2.5 flex justify-between"
                        >
                            <div class="shine rounded-lg w-1/3" />
                            <div class="shine rounded-lg w-3/5" />
                        </div>
                    </template>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watchEffect, onMounted } from 'vue';
import { useEventListener } from '@vueuse/core';
import routeName from '@/router/constant.js';
import { useRoute } from 'vue-router';

export default {
    name: 'CardPolicy',

    setup() {
        const route = useRoute();
        const isFold = ref(true);
        const windowWidth = ref(window.innerWidth);

        const contentArray = ref([
            { show: true },
            { show: true, isFold },
            { show: true, isFold },
            { show: route.name !== routeName.POLICY_BASIC }
        ]);

        const foldCard = () => {
            isFold.value = windowWidth.value > 768;
        };

        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                windowWidth.value = window.innerWidth;
            });
        });

        watchEffect(() => {
            isFold.value = windowWidth.value < 768;
        });

        return {
            isFold,
            contentArray,
            foldCard
        };
    },
};
</script>

<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.4s linear;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 100px;
    overflow: hidden;
}

.shine {
    position: relative;
    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: shimmer 3s infinite;
        content: "";
    }
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}
</style>
